import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ErrorBag } from 'src/models/ErrorModel';
import { Store } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { FORM_ID } from 'src/models/FormModel';
// eslint-disable-next-line import/no-extraneous-dependencies
import MomentUtils from '@date-io/moment';
import { Moment } from 'moment';

interface Props {
  disabled?: boolean,
  minDate?: Date,
  label: string,
  name: string,
  onChange:any,
  value?: Nullable<Moment>,
  required?: boolean,
  form: FORM_ID,
  error?: boolean,
  showTime?: boolean,
  style?: any,
}

const FormDateTimePicker = (props: Props) => {
  const {
    label, name, onChange, value, required,
    form, disabled, minDate, error, showTime, style,
  } = props;

  const errors: ErrorBag =
  useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  const format = showTime ? 'MM/DD/YYYY hh:mm' : 'MM/DD/YYYY';

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DateTimePicker
        minDate={minDate}
        views={['year', 'date', 'month', 'hours', 'minutes']}
        required={!!required}
        autoOk
        variant="inline"
        format={format}
        margin="normal"
        id={`date-picker-${name}`}
        label={label}
        value={value || null}
        onChange={onChange}
        disabled={disabled}
        error={error || !!errors[name]}
        helperText={errors[name] && errors[name].join(',')}
        key={`datepicker-${name}`}
        style={style} />
    </MuiPickersUtilsProvider>
  );
};

export default FormDateTimePicker;
